<template>
  <div class="home_about">
    <div class="gsjj">
      <p class="p1">核心优势</p>
      <div class="fg"></div>
    </div>
    <div class="list_box">
      <div class="box_item" v-for="(item, index) in list" :key="index">
        <img :src="item.imgUrl" alt="" />
        <div class="title">{{ item.title }}</div>
        <div class="content">{{ item.content }}</div>
      </div>
    </div>
    <div class="gsjj">
      <p class="p1">公司简介</p>
      <div class="fg"></div>
    </div>
    <div class="list_banner">
      <div class="banner">
        <img src="@/assets/images/about/profile1.png" alt="" />
        <div class="right">
          <div class="title">泛钛科技</div>
          <div class="line"></div>
          <div class="content">
            杭州泛钛科技有限公司成立于2017年7月，注册地在于最具创业创新活力的杭州市。在以移动互联网、大数据、云计算、人工智能为代表的新一代信息化浪潮中，公司聚焦于泛金融大科技、政企数字化领域，以人才和技术为核心，以科技服务和技术VC为抓手，乘风破浪，扬帆起航。公司秉承“重诺守信、严谨求是”的企业精神和“以人为本，客户至上”的经营理念
          </div>
        </div>
      </div>
      <div class="banner" style="transform: translateX(80px);">
        <div class="right" style="background: #F7F7F7;">
          <div class="title">专业团队管理</div>
          <div class="line"></div>
          <div class="content">
            公司拥有一支在金融、互联网、IT行业经验特别丰富的团队，核心团队成员均来自蚂蚁金服、恒生电子、连连支付等著名的互联网科技企业。在分布式、微服务、大数据、云计算等技术领域，在支付清算、风险管理等业务领域，在企业运营、研发管理、质量管理等经营领域，都有很深的积累。
          </div>
        </div>
        <img src="@/assets/images/about/profile2.png" alt="" />
      </div>
      <div class="banner">
        <img src="@/assets/images/about/profile3.png" alt="" />
        <div class="right">
          <div class="title">技术服务体系</div>
          <div class="line"></div>
          <div class="content">
            在科技服务板块，公司以自主研发的二次开发技术平台为基础层，形成了以聚合支付、电子账户、流控审批等为业务公共层，消费金融、融资租赁、积分商城等为应用产品层的技术产品体系，并以此为基础形成了产品实施、项目外包、人力外包等多种形式的服务体系，自公司成立以来，相关产品及解决方案在多家金融机构落地，与传化支付、连连支付等知名金融服务企业有长期和良好的合作关系，并获得客户广泛好评。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { coreAdvantages } from "../text/index";
export default {
  components: {},
  props: {},
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.list = coreAdvantages();
  },
};
</script>

<style lang="scss" scoped>
.home_about {
  background: #fff;
  margin: 20px 160px;
  // padding-top: 0.5rem;
  // background-color: #f10065;
}
.gsjj {
  width: 208px;
  height: 99px;
  // background-color: #073875;
  margin: 0 auto;
  padding-top: 83px;
  // margin-top: 100px;
  margin-bottom: 80px;
}
.fg {
  width: 165px;
  height: 5px;
  background: #0a41ff;
  border-radius: 0px 0px 0px 0px;
  margin: 47px 21px 0px 22px;
}
.p1 {
  width: 208px;
  height: 52px;
  font-size: 52px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  background-color: rgba(255, 255, 255, 0);

  line-height: 93px;
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
}
.list_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .box_item {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 45px;
    width: 435px;
    height: 530px;
    box-shadow: 5px 5px 5px 5px #f4f5f8d8;
    img {
      width: 108px;
      height: 108px;
    }
    .title {
      margin-top: 60px;
      font-size: 36px;
      font-weight: bold;
      color: #333333;
    }
    .content {
      font-size: 24px;
      color: #666666;
      line-height: 45px;
      margin-top: 50px;
    }
  }
}
.list_banner {
  .banner {
    display: flex;
    margin-bottom: 80px;
    border: 1px solid #d8d8d8;
    img {
      width: 621px;
      height: 420px;
    }
    .right {
      display: flex;
      flex-direction: column;
      align-items: start;
      padding:0 70px;
      .title {
        font-size: 36px;
        margin-top: 30px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      .line {
        width: 20px;
        height: 2px;
        background: #666666;
        margin: 30px 0;
      }
      .content {
        font-size: 24px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        line-height: 45px;
      }
    }
  }
}
</style>